import { useEffect } from 'react'
import { FaFilter } from 'react-icons/fa'
import { VscClearAll } from 'react-icons/vsc'
import Select from 'react-select'
import Input from '../../shared/components/form/input'
import Button from '../../shared/components/Button/Button'
import SelectStyles from '../../shared/Select/SelectStyle'

function GeneratorFilterModal({ filters, onChange, onClear, onClose }) {

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [onClose])

    const CONSUMABLE_OPTIONS = [
        { value: 'all', label: 'Todos' },
        { value: 'primaryAir', label: 'Ar Primário' },
        { value: 'secundaryAir', label: 'Ar Secundário' },
        { value: 'primaryComb', label: 'Comb. Primária' },
        { value: 'secundaryComb', label: 'Comb. Secundária' },
        { value: 'waterFilter', label: 'Filtro de Água' },
        { value: 'lubrificant', label: 'Lubrificante' },
        { value: 'oil', label: 'Óleo' },
        { value: 'racor', label: 'Racor' },
        { value: 'hose', label: 'Mangueira' },
        { value: 'straps', label: 'Correias' },
    ]
    const consumableFieldOption = CONSUMABLE_OPTIONS.find(o => o.value === filters.consumableField) || CONSUMABLE_OPTIONS[0]

    const hasActive = filters.status !== 'all' || filters.linked !== 'all' || filters.manufacturer || filters.engine || filters.power

    return (
        <div className="fm-overlay" onClick={onClose}>
            <div className="fm-box gen-filter-modal" onClick={(e) => e.stopPropagation()}>

                {/* ── Header ── */}
                <div className="fm-header">
                    <div className="fm-header-top">
                        <div className="fm-header-left">
                            <FaFilter size={24} className="fm-header-icon" />
                            <div>
                                <p className="fm-title">Filtrar geradores</p>
                                <span className="fm-accent" />
                            </div>
                        </div>
                        <button className="fm-close shd-modal-close" onClick={onClose}>X</button>
                    </div>
                    <div className="fm-header-actions">
                        <Button variant="cancel" icon={VscClearAll} onClick={onClear}>Limpar</Button>
                    </div>
                </div>

                {/* ── Body ── */}
                <div className="fm-body">

                    <div className="fm-section">
                        <span className="fm-label">Status</span>
                        <div className="fm-status-row">
                            {[
                                { value: 'all',      label: 'Todos' },
                                { value: 'active',   label: 'Ativos' },
                                { value: 'disabled', label: 'Desabilitados' },
                            ].map(opt => (
                                <button
                                    key={opt.value}
                                    className={`fm-status-opt ${filters.status === opt.value ? 'fm-status-opt-active' : ''}`}
                                    onClick={() => onChange('status', opt.value)}
                                >
                                    {opt.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Vínculo</span>
                        <div className="fm-status-row">
                            {[
                                { value: 'all',       label: 'Todos' },
                                { value: 'linked',    label: 'Vinculados' },
                                { value: 'unlinked',  label: 'Sem cliente' },
                            ].map(opt => (
                                <button
                                    key={opt.value}
                                    className={`fm-status-opt ${filters.linked === opt.value ? 'fm-status-opt-active' : ''}`}
                                    onClick={() => onChange('linked', opt.value)}
                                >
                                    {opt.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Filtros e Consumíveis</span>
                        <Select
                            options={CONSUMABLE_OPTIONS}
                            styles={SelectStyles}
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            value={consumableFieldOption}
                            onChange={(opt) => onChange('consumableField', opt.value)}
                        />
                        <Input
                            type="text"
                            name="consumableSearch"
                            placeholder={consumableFieldOption.value === 'all'
                                ? 'Digite e busca em todos os filtros/consumíveis...'
                                : `Ex: valor de ${consumableFieldOption.label}...`}
                            value={filters.consumableSearch}
                            handleOnChange={(e) => onChange('consumableSearch', e.target.value)}
                        />
                    </div>

                    <div className="gen-filter-grid-2">
                        <div className="fm-section">
                            <span className="fm-label">Fabricante</span>
                            <Input
                                type="text"
                                name="manufacturer"
                                placeholder="Ex: Stemac, Cummins..."
                                value={filters.manufacturer}
                                handleOnChange={(e) => onChange('manufacturer', e.target.value)}
                            />
                        </div>

                        <div className="fm-section">
                            <span className="fm-label">Motor</span>
                            <Input
                                type="text"
                                name="engine"
                                placeholder="Ex: Perkins, Scania..."
                                value={filters.engine}
                                handleOnChange={(e) => onChange('engine', e.target.value)}
                            />
                        </div>

                        <div className="fm-section">
                            <span className="fm-label">Potência</span>
                            <Input
                                type="text"
                                name="power"
                                placeholder="Ex: 100 kVA..."
                                value={filters.power}
                                handleOnChange={(e) => onChange('power', e.target.value)}
                            />
                        </div>

                        <div className="fm-section">
                            <span className="fm-label">Painel</span>
                            <Input
                                type="text"
                                name="panel"
                                placeholder="Ex: DSE, ComAp..."
                                value={filters.panel}
                                handleOnChange={(e) => onChange('panel', e.target.value)}
                            />
                        </div>

                        <div className="fm-section">
                            <span className="fm-label">Sist. de Injeção</span>
                            <Input
                                type="text"
                                name="injectionSystem"
                                placeholder="Ex: Common Rail, Mecânico..."
                                value={filters.injectionSystem}
                                handleOnChange={(e) => onChange('injectionSystem', e.target.value)}
                            />
                        </div>
                    </div>

                </div>


            </div>
        </div>
    )
}

export default GeneratorFilterModal
